import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Applications.deleteConfirmTitle'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.Common.deleteButton'),
        color: _vm.color,
        emit: 'delete'
      }],
      "showSelect": _vm.isActility,
      "checkBoxLable": _vm.$i18n_t('NiotaClassic.Devices.deleteFromActility')
    },
    on: {
      "cancel": _vm.closeDeletePrompt,
      "delete": _vm.deleteDevice,
      "is-selectecd": _vm.deleteFromRemote
    }
  }), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.deviceSingleUpdateDialog,
      callback: function ($$v) {
        _vm.deviceSingleUpdateDialog = $$v;
      },
      expression: "deviceSingleUpdateDialog"
    }
  }, [_c('niota-classic-devices-edit-form', {
    attrs: {
      "editedItem": _vm.editedItem,
      "deviceTypes": _vm.deviceTypes,
      "applications": _vm.applications
    },
    on: {
      "close": _vm.toggleEditDialog,
      "refreshList": _vm.refreshList
    }
  })], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.deviceUpdateDialog,
      callback: function ($$v) {
        _vm.deviceUpdateDialog = $$v;
      },
      expression: "deviceUpdateDialog"
    }
  }, [_c('niota-classic-devices-multiple-edit-form', {
    attrs: {
      "editAllFormDialog": _vm.selectedRows && _vm.selectedRows.length > 1,
      "selectedRows": _vm.selectedRows,
      "deviceTypes": _vm.deviceTypes,
      "applications": _vm.applications
    },
    on: {
      "close": _vm.toggleEditAllDialog,
      "refreshList": _vm.refreshList
    }
  })], 1), _c('core-n20-card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "offset": 24,
      "buttons": [{
        title: this.$i18n_t('Common.edit'),
        icon: 'fal fa-edit',
        action: 'showEditAllDialog',
        valid: _vm.isIotHubManager && _vm.selectedRows && _vm.selectedRows.length > 0
      }]
    },
    on: {
      "showEditAllDialog": _vm.toggleEditAllDialog
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-0"
  }, [_c(VTextField, {
    staticClass: "mb-4",
    attrs: {
      "data-cy": "common_search",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDataTable, {
    ref: "table-linked-devices",
    staticClass: "clickable",
    attrs: {
      "data-cy": "linked_devices",
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.tableHeaders,
      "footer-props": _vm.tableFooterProps,
      "item-key": "id",
      "show-select": _vm.isIotHubManager
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "input": _vm.rowSelectUpdate,
      "click:row": _vm.viewDevice
    },
    scopedSlots: _vm._u([{
      key: "item.title",
      fn: function (items) {
        return [_c('router-link', {
          attrs: {
            "to": `/niota-classic/devices/${items.item.id}/details`
          }
        }, [_vm._v("\n              " + _vm._s(items.item.title) + "\n            ")])];
      }
    }, {
      key: "item.eui",
      fn: function (items) {
        return [_vm.isCopySupported() ? _c('div', {
          staticClass: "euiElement",
          on: {
            "click": function ($event) {
              return _vm.copyToClipboard($event, items.item.eui);
            }
          }
        }, [_c('pre', [_vm._v(_vm._s(items.item.eui))]), _c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-copy")])], 1) : _c('div', {
          staticClass: "euiElement"
        }, [_c('pre', [_vm._v(_vm._s(items.item.eui))])])];
      }
    }, {
      key: "item.createdAt",
      fn: function (items) {
        return [_vm._v("\n            " + _vm._s(_vm.localizeDate(items.item.createdAt)) + "\n          ")];
      }
    }, _vm.isIotHubManager ? {
      key: "item.actions",
      fn: function (items) {
        return [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": "",
            "data-cy": "edit_device"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.editDevice(items.item);
            }
          }
        }, [_vm._v("\n              fal fa-edit\n            ")]), _vm._v("\n             \n            "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": "",
            "data-cy": "delete_device"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.showDeletePrompt(items.item);
            }
          }
        }, [_vm._v("\n              fal fa-trash-alt\n            ")])];
      }
    } : null, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }], null, true)
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };